import dayjs from 'dayjs';
import { useCallback } from 'react';

export const useFormatDate = () =>
  useCallback((date: string | Date): string => {
    const d = dayjs(date);
    return d.isValid() ? d.format('YYYY-MM-DD') : '';
  }, []);
